var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 112,
    viewBox: "0 0 572 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2 88.6799L52.17 110.81L78.19 110.75L65.2 88.6799Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.14 44.3401L0 110.77H26.06L52.17 66.4701L39.14 44.3401Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.22 66.6999L104.5 111.15H130.43L91.18 44.6899L78.22 66.6999Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19 22.06L65.2 0L52.17 22.12L65.16 44.19L78.19 22.06Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9 47.4299C313.32 47.4299 321.17 54.6499 321.17 66.7899C321.17 76.2999 314.18 83.1799 304.03 84.5699L323.04 110.8H308.78L290.5 85.9799H264.92V110.8H253.73V47.4199H294.91L294.9 47.4299ZM264.91 58.5999V74.9799H296.5C303.03 74.9799 309.97 74.4499 309.97 66.7899C309.97 59.1299 301.07 58.5999 296.27 58.5999H264.9H264.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.9 111.86L433.13 70.5199L430.45 68.3199V110.81H419.26V46.3799H419.38L470.15 87.7199L472.83 89.9199V47.4299H484.02V111.86H483.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.15 110.81H243.39L204.68 45.03H204.45L165.74 110.81H178.98L185.61 99.36H223.42L230.15 110.81ZM204.56 66.24C209.99 74.99 212.32 79.12 217.79 88.43H191.22C196.93 78.75 199.09 74.99 204.56 66.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.97 110.81H571.21L532.5 45.03H532.27L493.56 110.81H506.8L513.43 99.36H551.24L557.97 110.81ZM532.38 66.24C537.81 74.99 540.14 79.12 545.61 88.43H519.04C524.75 78.75 526.91 74.99 532.38 66.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65 99.6299V84.2699H396.11V73.3399H352.65V58.6099H401.08V47.4299H341.45V110.81H402.83V99.6299H352.65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 571.21,
    height: 111.86,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.126ef8537394b271b66f7d10892d0e52.svg";
export { ForwardRef as ReactComponent };